module.exports = __webpack_public_path__ + "static/fonts/Simple-Line-Icons.f33df36.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SimpleLineIcons/Simple-Line-Icons.eot?v=2.4.0
// module id = 1152
// module chunks = 5